/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ContributedOfferShort } from './ContributedOfferShort';

export type SnapContributedOffer = {
    offer: ContributedOfferShort;
    milesAmount?: number;
    status: SnapContributedOffer.status;
};

export namespace SnapContributedOffer {

    export enum status {
        CONTRIBUTED = 'CONTRIBUTED',
        ISSUED = 'ISSUED',
    }


}

